import React, { Fragment } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../Layout/Layout";
import { ROUTES } from "./Routes";

const LayoutRoutes = () => {
  return (
    <Fragment>
      <Routes>
        {ROUTES.map(({ path, element }, i) => (
          <Route element={<Layout />} key={i}>
            <Route path={path} element={element} />
          </Route>
        ))}
      </Routes>
    </Fragment>
  );
};

export default LayoutRoutes;
